// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v4.23.4
// source: channel_message/media_event.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Consumer } from "../consumer/consumer";
import { Producer } from "../producer/producer";
import { ProducerSpatialLayerRequest } from "../producer/producer_spatial_layer_request";
import { TransportConnectionTimeout } from "../transport/transport_connection_timeout";

export const protobufPackage = "channel_message";

export enum MediaEventType {
  MEDIA_EVENT_TYPE_UNSPECIFIED = 0,
  MEDIA_EVENT_TYPE_TRANSPORT_CONNECTION_TIMEOUT = 1,
  MEDIA_EVENT_TYPE_PRODUCER_CREATED = 2,
  MEDIA_EVENT_TYPE_PRODUCER_PAUSED = 3,
  MEDIA_EVENT_TYPE_PRODUCER_RESUMED = 4,
  MEDIA_EVENT_TYPE_PRODUCER_CLOSED = 5,
  MEDIA_EVENT_TYPE_PRODUCER_FORCIBLY_CLOSED = 6,
  MEDIA_EVENT_TYPE_PRODUCER_MAX_SPATIAL_LAYER_REQUESTED = 7,
  MEDIA_EVENT_TYPE_PRODUCER_MAX_SPATIAL_LAYER_CHANGED = 8,
  MEDIA_EVENT_TYPE_CONSUMER_CLOSED = 9,
  MEDIA_EVENT_TYPE_CONSUMER_PAUSED = 10,
  MEDIA_EVENT_TYPE_CONSUMER_RESUMED = 11,
  MEDIA_EVENT_TYPE_CONSUMER_PREFERRED_LAYERS_CHANGED = 12,
  UNRECOGNIZED = -1,
}

export function mediaEventTypeFromJSON(object: any): MediaEventType {
  switch (object) {
    case 0:
    case "MEDIA_EVENT_TYPE_UNSPECIFIED":
      return MediaEventType.MEDIA_EVENT_TYPE_UNSPECIFIED;
    case 1:
    case "MEDIA_EVENT_TYPE_TRANSPORT_CONNECTION_TIMEOUT":
      return MediaEventType.MEDIA_EVENT_TYPE_TRANSPORT_CONNECTION_TIMEOUT;
    case 2:
    case "MEDIA_EVENT_TYPE_PRODUCER_CREATED":
      return MediaEventType.MEDIA_EVENT_TYPE_PRODUCER_CREATED;
    case 3:
    case "MEDIA_EVENT_TYPE_PRODUCER_PAUSED":
      return MediaEventType.MEDIA_EVENT_TYPE_PRODUCER_PAUSED;
    case 4:
    case "MEDIA_EVENT_TYPE_PRODUCER_RESUMED":
      return MediaEventType.MEDIA_EVENT_TYPE_PRODUCER_RESUMED;
    case 5:
    case "MEDIA_EVENT_TYPE_PRODUCER_CLOSED":
      return MediaEventType.MEDIA_EVENT_TYPE_PRODUCER_CLOSED;
    case 6:
    case "MEDIA_EVENT_TYPE_PRODUCER_FORCIBLY_CLOSED":
      return MediaEventType.MEDIA_EVENT_TYPE_PRODUCER_FORCIBLY_CLOSED;
    case 7:
    case "MEDIA_EVENT_TYPE_PRODUCER_MAX_SPATIAL_LAYER_REQUESTED":
      return MediaEventType.MEDIA_EVENT_TYPE_PRODUCER_MAX_SPATIAL_LAYER_REQUESTED;
    case 8:
    case "MEDIA_EVENT_TYPE_PRODUCER_MAX_SPATIAL_LAYER_CHANGED":
      return MediaEventType.MEDIA_EVENT_TYPE_PRODUCER_MAX_SPATIAL_LAYER_CHANGED;
    case 9:
    case "MEDIA_EVENT_TYPE_CONSUMER_CLOSED":
      return MediaEventType.MEDIA_EVENT_TYPE_CONSUMER_CLOSED;
    case 10:
    case "MEDIA_EVENT_TYPE_CONSUMER_PAUSED":
      return MediaEventType.MEDIA_EVENT_TYPE_CONSUMER_PAUSED;
    case 11:
    case "MEDIA_EVENT_TYPE_CONSUMER_RESUMED":
      return MediaEventType.MEDIA_EVENT_TYPE_CONSUMER_RESUMED;
    case 12:
    case "MEDIA_EVENT_TYPE_CONSUMER_PREFERRED_LAYERS_CHANGED":
      return MediaEventType.MEDIA_EVENT_TYPE_CONSUMER_PREFERRED_LAYERS_CHANGED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MediaEventType.UNRECOGNIZED;
  }
}

export function mediaEventTypeToJSON(object: MediaEventType): string {
  switch (object) {
    case MediaEventType.MEDIA_EVENT_TYPE_UNSPECIFIED:
      return "MEDIA_EVENT_TYPE_UNSPECIFIED";
    case MediaEventType.MEDIA_EVENT_TYPE_TRANSPORT_CONNECTION_TIMEOUT:
      return "MEDIA_EVENT_TYPE_TRANSPORT_CONNECTION_TIMEOUT";
    case MediaEventType.MEDIA_EVENT_TYPE_PRODUCER_CREATED:
      return "MEDIA_EVENT_TYPE_PRODUCER_CREATED";
    case MediaEventType.MEDIA_EVENT_TYPE_PRODUCER_PAUSED:
      return "MEDIA_EVENT_TYPE_PRODUCER_PAUSED";
    case MediaEventType.MEDIA_EVENT_TYPE_PRODUCER_RESUMED:
      return "MEDIA_EVENT_TYPE_PRODUCER_RESUMED";
    case MediaEventType.MEDIA_EVENT_TYPE_PRODUCER_CLOSED:
      return "MEDIA_EVENT_TYPE_PRODUCER_CLOSED";
    case MediaEventType.MEDIA_EVENT_TYPE_PRODUCER_FORCIBLY_CLOSED:
      return "MEDIA_EVENT_TYPE_PRODUCER_FORCIBLY_CLOSED";
    case MediaEventType.MEDIA_EVENT_TYPE_PRODUCER_MAX_SPATIAL_LAYER_REQUESTED:
      return "MEDIA_EVENT_TYPE_PRODUCER_MAX_SPATIAL_LAYER_REQUESTED";
    case MediaEventType.MEDIA_EVENT_TYPE_PRODUCER_MAX_SPATIAL_LAYER_CHANGED:
      return "MEDIA_EVENT_TYPE_PRODUCER_MAX_SPATIAL_LAYER_CHANGED";
    case MediaEventType.MEDIA_EVENT_TYPE_CONSUMER_CLOSED:
      return "MEDIA_EVENT_TYPE_CONSUMER_CLOSED";
    case MediaEventType.MEDIA_EVENT_TYPE_CONSUMER_PAUSED:
      return "MEDIA_EVENT_TYPE_CONSUMER_PAUSED";
    case MediaEventType.MEDIA_EVENT_TYPE_CONSUMER_RESUMED:
      return "MEDIA_EVENT_TYPE_CONSUMER_RESUMED";
    case MediaEventType.MEDIA_EVENT_TYPE_CONSUMER_PREFERRED_LAYERS_CHANGED:
      return "MEDIA_EVENT_TYPE_CONSUMER_PREFERRED_LAYERS_CHANGED";
    case MediaEventType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface MediaEvent {
  eventType: MediaEventType;
  producer?: Producer | undefined;
  consumer?: Consumer | undefined;
  producerSpatialLayerRequest?: ProducerSpatialLayerRequest | undefined;
  transportConnectionTimeout?: TransportConnectionTimeout | undefined;
}

function createBaseMediaEvent(): MediaEvent {
  return {
    eventType: 0,
    producer: undefined,
    consumer: undefined,
    producerSpatialLayerRequest: undefined,
    transportConnectionTimeout: undefined,
  };
}

export const MediaEvent: MessageFns<MediaEvent> = {
  encode(message: MediaEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.eventType !== 0) {
      writer.uint32(8).int32(message.eventType);
    }
    if (message.producer !== undefined) {
      Producer.encode(message.producer, writer.uint32(18).fork()).join();
    }
    if (message.consumer !== undefined) {
      Consumer.encode(message.consumer, writer.uint32(26).fork()).join();
    }
    if (message.producerSpatialLayerRequest !== undefined) {
      ProducerSpatialLayerRequest.encode(message.producerSpatialLayerRequest, writer.uint32(34).fork()).join();
    }
    if (message.transportConnectionTimeout !== undefined) {
      TransportConnectionTimeout.encode(message.transportConnectionTimeout, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MediaEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMediaEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.eventType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.producer = Producer.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.consumer = Consumer.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.producerSpatialLayerRequest = ProducerSpatialLayerRequest.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.transportConnectionTimeout = TransportConnectionTimeout.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MediaEvent {
    return {
      eventType: isSet(object.eventType) ? mediaEventTypeFromJSON(object.eventType) : 0,
      producer: isSet(object.producer) ? Producer.fromJSON(object.producer) : undefined,
      consumer: isSet(object.consumer) ? Consumer.fromJSON(object.consumer) : undefined,
      producerSpatialLayerRequest: isSet(object.producerSpatialLayerRequest)
        ? ProducerSpatialLayerRequest.fromJSON(object.producerSpatialLayerRequest)
        : undefined,
      transportConnectionTimeout: isSet(object.transportConnectionTimeout)
        ? TransportConnectionTimeout.fromJSON(object.transportConnectionTimeout)
        : undefined,
    };
  },

  toJSON(message: MediaEvent): unknown {
    const obj: any = {};
    if (message.eventType !== 0) {
      obj.eventType = mediaEventTypeToJSON(message.eventType);
    }
    if (message.producer !== undefined) {
      obj.producer = Producer.toJSON(message.producer);
    }
    if (message.consumer !== undefined) {
      obj.consumer = Consumer.toJSON(message.consumer);
    }
    if (message.producerSpatialLayerRequest !== undefined) {
      obj.producerSpatialLayerRequest = ProducerSpatialLayerRequest.toJSON(message.producerSpatialLayerRequest);
    }
    if (message.transportConnectionTimeout !== undefined) {
      obj.transportConnectionTimeout = TransportConnectionTimeout.toJSON(message.transportConnectionTimeout);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MediaEvent>, I>>(base?: I): MediaEvent {
    return MediaEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MediaEvent>, I>>(object: I): MediaEvent {
    const message = createBaseMediaEvent();
    message.eventType = object.eventType ?? 0;
    message.producer = (object.producer !== undefined && object.producer !== null)
      ? Producer.fromPartial(object.producer)
      : undefined;
    message.consumer = (object.consumer !== undefined && object.consumer !== null)
      ? Consumer.fromPartial(object.consumer)
      : undefined;
    message.producerSpatialLayerRequest =
      (object.producerSpatialLayerRequest !== undefined && object.producerSpatialLayerRequest !== null)
        ? ProducerSpatialLayerRequest.fromPartial(object.producerSpatialLayerRequest)
        : undefined;
    message.transportConnectionTimeout =
      (object.transportConnectionTimeout !== undefined && object.transportConnectionTimeout !== null)
        ? TransportConnectionTimeout.fromPartial(object.transportConnectionTimeout)
        : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
